import { CONTRACTOR_BILL_ENTRY_DETAIL_USERFORM_RESET, CONTRACTOR_BILL_ENTRY_USERFORM_RESET, CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_FAILURE_DK, CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_REQUEST_DK, CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_SUCCESS_DK, CREATE_CONTRACTOR_BILL_ENTRIES_FAILURE, CREATE_CONTRACTOR_BILL_ENTRIES_REQUEST, CREATE_CONTRACTOR_BILL_ENTRIES_SUCCESS, CREATE_USER_FORM_CONTRACTOR_BILL_DETAIL_DK, CREATE_USER_FORM_CONTRACTOR_BILL_DK, DELETE_CONTRACTOR_BILL_FAILURE, DELETE_CONTRACTOR_BILL_REQUEST, FETCH_CONTRACTOR_BILL_BANK_DETAILS_FAILURE, FETCH_CONTRACTOR_BILL_BANK_DETAILS_REQUEST, FETCH_CONTRACTOR_BILL_BANK_DETAILS_SUCCESS, FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_FAILURE, FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_REQUEST, FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_SUCCESS, FETCH_CONTRACTOR_BILL_ENTRIES_FAILURE_DK, FETCH_CONTRACTOR_BILL_ENTRIES_REQUEST_DK, FETCH_CONTRACTOR_BILL_ENTRIES_SUCCESS_DK, FETCH_CONTRACTOR_BILL_INVOICE_FAILURE, FETCH_CONTRACTOR_BILL_INVOICE_REQUEST, FETCH_CONTRACTOR_BILL_INVOICE_SUCCESS, FETCH_CONTRACTOR_BILL_PRICE_RESET, FETCH_CONTRACTOR_BILL_PRICE_SUCCESS, FETCH_CONTRACTOR_BILL_SALES_ORDER_FAILURE, FETCH_CONTRACTOR_BILL_SALES_ORDER_REQUEST, FETCH_CONTRACTOR_BILL_SALES_ORDER_SUCCESS, FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_FAILURE, FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_REQUEST, FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_SUCCESS, FETCH_SINGLE_CONTRACTOR_BILL_MASTER_FAILURE, FETCH_SINGLE_CONTRACTOR_BILL_MASTER_REQUEST, FETCH_SINGLE_CONTRACTOR_BILL_MASTER_SUCCESS, RESET_CONTRACTOR_BILL_INVOICE, UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_FAILURE_DK, UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_REQUEST_DK, UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_SUCCESS_DK, UPDATE_CONTRACTOR_BILL_ENTRIES_FAILURE, UPDATE_CONTRACTOR_BILL_ENTRIES_REQUEST, UPDATE_CONTRACTOR_BILL_ENTRIES_SUCCESS } from "./contractorbill.actionType";


export const CONTRACTOR_BILL = 'contractorbill';

let initialState = {
    loading: false,
    contractorbillData: [],
    contractorbillDataEdit: [],
    userform: {
        fldFKSupplierID: '',
    },
    contractorbilldetailform: {},
    detailsId: '',
    salesOrderList: [],
    supplierList: [],
    contractordetailsId: '',
    contractorbillInvoiceV2: [],
    refetch: false
}

export let contractorBillEntriesReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {

        case FETCH_CONTRACTOR_BILL_ENTRIES_REQUEST_DK:
        case CREATE_CONTRACTOR_BILL_ENTRIES_REQUEST:
        case FETCH_CONTRACTOR_BILL_SALES_ORDER_REQUEST:
        case FETCH_CONTRACTOR_BILL_BANK_DETAILS_REQUEST:
        case CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_CONTRACTOR_BILL_MASTER_REQUEST:
        case FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_REQUEST:
        case DELETE_CONTRACTOR_BILL_REQUEST:
        case UPDATE_CONTRACTOR_BILL_ENTRIES_REQUEST:
        case UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_REQUEST_DK:
        case FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_REQUEST:
        case FETCH_CONTRACTOR_BILL_INVOICE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CONTRACTOR_BILL_ENTRIES_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                contractorbillData: updatePayload
            };
        case FETCH_CONTRACTOR_BILL_PRICE_SUCCESS:
            return {
                ...state,
                loading: false,
                contractorPrice: updatePayload.CON

            }
        case FETCH_CONTRACTOR_BILL_PRICE_RESET:
            return {
                ...state,
                loading: false,
                contractorPrice: []

            }
        case FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                contractorbillDataEdit: updatePayload,
                refetch: !state.refetch,

            };
        case CREATE_USER_FORM_CONTRACTOR_BILL_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_CONTRACTOR_BILL_DETAIL_DK:
            return {
                ...state,
                loading: false,
                contractorbilldetailform: {
                    ...state.contractorbilldetailform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_CONTRACTOR_BILL_ENTRIES_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKSupplier: '',
                },
                detailsId: updatePayload
            };
        case FETCH_CONTRACTOR_BILL_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderList: updatePayload
            };
        case FETCH_CONTRACTOR_BILL_BANK_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierList: updatePayload
            };
        case CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                contractordetailsId: updatePayload
            };
        case FETCH_SINGLE_CONTRACTOR_BILL_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload,
                // contractorbilldetailform: updatePayload,

            };
        case FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userformDetail: updatePayload,

                //salesOrderList: updatePayload
            };
        case UPDATE_CONTRACTOR_BILL_ENTRIES_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKSupplierID: '',
                    fldCGSTValue: 0,
                    fldSGSTValue: 0
                },


            };
        case UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                contractorbilldetailform: {}

            };

        case CONTRACTOR_BILL_ENTRY_USERFORM_RESET:
            return {
                ...state,

                userform: {
                    fldUnitName: '',


                    fldCGSTValue: 0,
                    fldSGSTValue: 0,
                    fldInvoiceNo: '',
                    fldStyleName: '',
                    fldSupplierName: '',
                    fldSupplierRef: '',
                    fldBuyerDCNO: '',
                    fldBankName: '',
                    fldAccNo: '',
                    fldBranch: '',
                    fldIFSCCode: '',
                    fldRoundoff: '',
                    fldGrandTotalValue: 0,
                },




            };
        case CONTRACTOR_BILL_ENTRY_DETAIL_USERFORM_RESET:
            return {
                ...state,

                contractorbilldetailform: {
                    fldStyleNumber: '',
                    fldQuantity: 0,
                    fldRate: 0,
                    fldArticleDesc: '',
                    fldItemTotalValue: 0,
                },
                salesOrderList: [],


            };
        case FETCH_CONTRACTOR_BILL_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                contractorbillInvoiceV2: updatePayload?.CON
            };
        case RESET_CONTRACTOR_BILL_INVOICE:
            return {
                ...state,
                contractorbillInvoiceV2: []
            };
        case FETCH_CONTRACTOR_BILL_ENTRIES_FAILURE_DK:
        case CREATE_CONTRACTOR_BILL_ENTRIES_FAILURE:
        case FETCH_CONTRACTOR_BILL_SALES_ORDER_FAILURE:
        case FETCH_CONTRACTOR_BILL_BANK_DETAILS_FAILURE:
        case CREATE_CONTRACTOR_BILL_ENTRIES_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_CONTRACTOR_BILL_MASTER_FAILURE:
        case FETCH_SINGLE_CONTRACTOR_BILL_DETAIL_FAILURE:
        case DELETE_CONTRACTOR_BILL_FAILURE:
        case UPDATE_CONTRACTOR_BILL_ENTRIES_FAILURE:
        case UPDATE_CONTRACTOR_BILL_ENTRIES_DETAILS_FAILURE_DK:
        case FETCH_CONTRACTOR_BILL_DETAILS_EDIT_GET_FAILURE:
        case FETCH_CONTRACTOR_BILL_INVOICE_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};